import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { rolesQueries } from '@/services/rolesPrivilege/roles.queries';

export const useRoleAgents = (roleType: 'admin' | 'club' | 'customer' | 'affiliate', roleTypeId: string) => {
  const { data, isLoading } = useQuery({
    ...rolesQueries.agent(roleType, roleTypeId),
  });

  return { agents: data?.data || [], isLoading };
};
